module.exports = __webpack_public_path__ + "static/index/img/baikal-102.d00c7994.jpg";